// removed by extract-text-webpack-plugin
module.exports = {"work":"_1mXlwrruJa0J7rL4ooBSCj_0","workItems":"_3bEs8Fd1NkfizfXBAIS6f_0","item":"_2cB-B_jqsNE1eXEV6iPoEk_0","thumbnail":"_3KUeP8-28md6_s5DdJ7UCT_0","title":"_1A75HhoNvaP0OM-64X1I12_0","description":"_1_AUbpB9Xm_B9CsVnYdAT6_0"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"extract":true,"remove":true}!./~/vue-style-loader!./~/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-rewriter.js?id=data-v-6deced4f!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Home.vue
// module id = 60
// module chunks = 2